export default __webpack_public_path__ + "static/media/Group 1715.a1f641b2.png";